import { Component, Input, OnInit } from '@angular/core';
import { LocaleService } from '../../service/locale.service';

@Component({
  selector: 'app-empty',
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.scss'],
  host: { class: 'animate__animated animate__fadeIn', '[class.empty]': 'smallText' },
})
export class EmptyComponent implements OnInit {
  @Input() text: string = this.localeService.getValue('no_record');
  @Input() icon: string = 'assets/svg/data-empty.svg';
  @Input() smallText: boolean = false;
  @Input() translateText: boolean = false;

  @Input() title = this.localeService.getValue('empty_state_title');
  @Input() message = this.localeService.getValue('empty_state_message');
  @Input() translateTitle: boolean = false;
  @Input() translateMessage: boolean = false;

  constructor(private localeService: LocaleService) {}

  ngOnInit() {}

  get displayText() {
    return this.translateText ? this.localeService.getValue(this.text) : this.text;
  }

  get displayTitle() {
    return this.translateTitle ? this.localeService.getValue(this.title) : this.title;
  }

  get displayMessage() {
    return this.translateMessage ? this.localeService.getValue(this.message) : this.message;
  }
}
